import { render, staticRenderFns } from "./PackageSelectionStep.vue?vue&type=template&id=266b795b"
import script from "./PackageSelectionStep.vue?vue&type=script&lang=js"
export * from "./PackageSelectionStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports